import useCachedSelectionList from '../base/useCachedList';
import { useFindManufacturersForSelectionLazy } from './useFindManufacturersForSelection';

const useCachedManufacturerList = () => {
  return useCachedSelectionList(
    'manufacturerList',
    useFindManufacturersForSelectionLazy
  );
};

export default useCachedManufacturerList;
